import axios from 'axios';
import BaseAPI from './base/base-api';

class LayoutAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'layout';
}

export default new LayoutAPI();